import { render } from "./ListEvent.vue?vue&type=template&id=485da212"
import script from "./ListEvent.vue?vue&type=script&lang=js"
export * from "./ListEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__